import script from "./NavbarView.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarView.vue?vue&type=script&setup=true&lang=js"

import "./NavbarView.vue?vue&type=style&index=0&id=4bc51613&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bc51613"]])

export default __exports__